document.addEventListener('DOMContentLoaded', function() {
    const filterForm = document.getElementById('CollectionFiltersForm');
    const DEFAULT_MIN_PRICE = 0; 

    // Product cards navigation (ignore clicks on any input)
    document.querySelectorAll('.product-card').forEach(function(card) {
        card.addEventListener('click', function(e) {
            if (e.target.closest('input, label, .filter-content')) return;
            const url = card.getAttribute('data-url');
            if (url) window.location.href = url;
        });
    });

    // View switcher
    document.querySelectorAll('.view-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            const grid = document.querySelector('.product-grid');
            grid.classList.remove('grid-3', 'grid-4', 'grid-list');
            grid.classList.add('grid-' + this.getAttribute('data-columns'));
        });
    });

    // Collapse/expand each filter
    document.querySelectorAll('.filter-header').forEach(function(header) {
        header.addEventListener('click', function(e) {
            if (e.target.closest('.reset-link')) return;
            header.classList.toggle('active');
            const content = header.nextElementSibling;
            content.style.display = (content.style.display === 'block') ? 'none' : 'block';
        });
    });

    // Prevent clicks inside filter content from bubbling to header
    document.querySelectorAll('.filter-content').forEach(function(content) {
        content.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    if (filterForm) {
        // Auto-submit on checkbox & select change
        filterForm.addEventListener('change', function(e) {
            const t = e.target;
            if (t.matches('input[type="checkbox"], select')) {
                filterForm.submit();
            }
        });

        // Price inputs → submit only on blur or Enter
        const priceInputs = filterForm.querySelectorAll('input[type="number"]');
        priceInputs.forEach(inp => {
            inp.addEventListener('blur', () => {
                if (inp.value !== "") filterForm.submit();
            });
            inp.addEventListener('keypress', (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    filterForm.submit();
                }
            });
        });
    }

    //  Preserve min/max price values from URL OR set default
    const urlParams = new URLSearchParams(window.location.search);
    const minInput = document.getElementById("min-price-input");
    const maxInput = document.getElementById("max-price-input");

    if (minInput) {
      if (urlParams.has(minInput.name)) {
        minInput.value = urlParams.get(minInput.name);
      } else {
        minInput.value = DEFAULT_MIN_PRICE; 
      }
    }

    if (maxInput && urlParams.has(maxInput.name)) {
      maxInput.value = urlParams.get(maxInput.name);
    }
});